import { Navigate, useLocation } from 'react-router-dom';

export const RemoveTrailingSlash = () => {
    const location = useLocation();
    if (location.pathname.length > 1 && location.pathname.endsWith('/')) {
        const newPath =
            location.pathname.slice(0, -1) + location.search + location.hash;
        return <Navigate to={newPath} replace />;
    }

    return null;
};

export default RemoveTrailingSlash;
